import { SvgIcon, SvgIconProps } from '@mui/material';

const ArrowBottom = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.71799 13.0732C4.32728 12.6831 4.32623 12.05 4.71604 11.6591C5.10611 11.2685 5.73925 11.2674 6.1301 11.6572L10.9826 16.5029L10.9748 5.08395C10.9748 4.53193 11.4227 4.08433 11.9748 4.08395C12.5269 4.0838 12.9744 4.53092 12.9748 5.08297L12.9826 16.5058L17.8391 11.6572C18.23 11.2674 18.8631 11.2684 19.2532 11.6591C19.6428 12.05 19.6427 12.6832 19.2522 13.0732L12.6916 19.623C12.3014 20.0126 11.669 20.0122 11.2785 19.623L4.71799 13.0732Z'
        fill='#1C1F1F'
      />
    </SvgIcon>
  );
};

export default ArrowBottom;
